module.exports = __webpack_public_path__ + "static/media/boats-orange.0cd3527f.jpg";